import { useState, type ReactNode } from 'react'
import type { ServerApiClient } from '../../../data/ServerApiClient'
import { startCfoCheckout } from './cfoBilling'
import { trimStr } from './cfoFormat'

/**
 * Shared "this is part of Pro" upsell shown in place of a Pro-only surface when
 * the workbook's tenant is on Essentials (see `cfoProFeaturesAvailable`). The
 * button starts a monthly Pro checkout; annual is offered in the shell-wide
 * `CfoPlanBanner`. The server independently enforces the hard gate (403), so
 * this is the friendly UX, not the security boundary.
 */
export function CfoProUpgradeNotice({
  appApi,
  workbookId,
  title,
  children,
}: {
  appApi: ServerApiClient
  workbookId: string | null
  title: string
  children: ReactNode
}) {
  const wb = trimStr(workbookId)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  return (
    <article className="cfo-shell-notice" role="status" style={{ marginBottom: 'var(--s4)' }}>
      <strong>{title}</strong>
      <p style={{ margin: '6px 0', color: 'var(--muted)' }}>{children}</p>
      <button
        type="button"
        className="btn ghost"
        disabled={!wb || busy}
        onClick={() => {
          if (!wb) return
          setBusy(true)
          setError('')
          startCfoCheckout(appApi, wb, 'pro', 'monthly').catch((e: any) => {
            setBusy(false)
            setError(trimStr(e?.message || e) || 'Could not start checkout — please try again.')
          })
        }}
      >
        {busy ? 'Starting checkout…' : 'Upgrade to Pro — $349/mo'}
      </button>
      {error ? <p style={{ margin: '6px 0 0', color: 'var(--muted)' }}>{error}</p> : null}
    </article>
  )
}
